module.exports = __webpack_public_path__ + "static/media/Profile-Moderator-01-Rekha-Reddy.4c1adc13.png";